export var DatasourceType;
(function (DatasourceType) {
    DatasourceType["Table"] = "table";
    DatasourceType["Druid"] = "druid";
})(DatasourceType || (DatasourceType = {}));
export default {};
//# sourceMappingURL=Datasource.js.map